module.exports = __webpack_public_path__ + "img/rabt2.d33139b6.jpg";